/* ======================================================
DOG MOM LIFESTYLES
Gift Product – Dog Profile Card Script

Runs on:
- /products/ultimate-dog-mom-gift-box
- /products/ultimate-dog-mom-gift-box-vip

Converts Appstle dropdown fields to pill selectors and
adds a cleaner two-step layout.

Original selects remain hidden and still submit line
item properties for Shopify/Appstle.
====================================================== */

(function () {
  const giftHandles = [
    "/products/ultimate-dog-mom-gift-box",
    "/products/ultimate-dog-mom-gift-box-vip"
  ];

  const isGiftPage = giftHandles.some((path) =>
    window.location.pathname.includes(path)
  );

  if (!isGiftPage) return;

  document.body.classList.add("dml-gift-page");

  function isVipPage() {
    return window.location.pathname.includes("/products/ultimate-dog-mom-gift-box-vip");
  }

  function getIntroText() {
    return isVipPage()
      ? "Choose a few details so we can personalise the gift for the dog and their human. We use these to match toy sizes and treats to the pup — and to send the included Dog Mom tee in the perfect size."
      : "Choose a few details so we can make the gift feel personal for both the dog and their human. We use these to pick the right toy sizes and treats — and to make sure any surprises for the dog mom are the right fit too.";
  }

  function updateErrorState(select, pillGroup, fieldCard) {
    if (!select.required) return;

    const hasValue = !!(select.value && select.value.trim() !== "");
    pillGroup.classList.toggle("has-error", !hasValue);

    if (fieldCard) {
      fieldCard.classList.toggle("dml-has-error", !hasValue);
    }
  }

  

  function updatePlanHeading() {
    const title = document.querySelector(".appstle_widget_title");
    if (!title) return;

    title.textContent = "Choose the Plan";
  }

  function addQuestionHelp(fieldCard, labelText) {
    if (!fieldCard || fieldCard.querySelector(".dml-question-help")) return;

    const label = fieldCard.querySelector(".appstleCustomSelectFieldLabel");
    if (!label) return;

    const text = (labelText || "").toLowerCase().trim();
    let help = "";

    if (text.includes("allerg")) {
      help = "Pick the safest treat option for the pup.";
    } else if (text.includes("toy")) {
      help = "Choose toys or swap for extra treats.";
    } else if (text.includes("shirt")) {
      help = isVipPage()
        ? "Unisex fit for the included tee."
        : "We may occasionally include a special surprise for the dog mom, so size helps us choose the best fit.";
    }

    if (!help) return;

    const helpEl = document.createElement("div");
    helpEl.className = "dml-question-help";
    helpEl.textContent = help;
    label.insertAdjacentElement("afterend", helpEl);
  }

  function markFullWidthFields(wrapper) {
  if (!wrapper) return;

  const fields = wrapper.querySelectorAll(".appstleCustomSelectField");

  fields.forEach((field) => {
    const label = field.querySelector(".appstleCustomSelectFieldLabel");
    const labelText = label ? label.textContent.toLowerCase() : "";

    if (
      labelText.includes("size is the pup") ||
      labelText.includes("shirt") ||
      labelText.includes("allerg") ||
      labelText.includes("toy")
    ) {
      field.classList.add("dml-span-full");
    }
  });

  if (fields.length >= 4) {
    wrapper.classList.add("dml-grid");
  }
}

  function syncActivePill(select, pillGroup) {
    const pills = pillGroup.querySelectorAll(".dml-pill");

    pills.forEach((pill) => {
      pill.classList.toggle("active", pill.dataset.value === select.value);
    });
  }

  function createPills(select) {
    if (!select || select.dataset.dmlProcessed === "true") return;

    const fieldCard = select.closest(".appstleCustomSelectField");
    if (!fieldCard) return;

    const label = fieldCard.querySelector(".appstleCustomSelectFieldLabel");
    const wrapper = select.parentElement;
    if (!wrapper) return;

    addQuestionHelp(fieldCard, label ? label.textContent : "");

    const options = Array.from(select.options).filter((o) => o.value !== "");
    if (!options.length) return;

    const existingPills = fieldCard.querySelector(".dml-pill-group");
    if (existingPills) {
      select.dataset.dmlProcessed = "true";
      select.classList.add("dml-pill-source");
      return;
    }

    const pillGroup = document.createElement("div");
    pillGroup.className = "dml-pill-group";

    options.forEach((option) => {
      const pill = document.createElement("button");
      pill.type = "button";
      pill.className = "dml-pill";
      pill.textContent = option.textContent.trim();
      pill.dataset.value = option.value;

      if (select.value === option.value) {
        pill.classList.add("active");
      }

      pill.addEventListener("click", function () {
        select.value = option.value;
        select.dispatchEvent(new Event("input", { bubbles: true }));
        select.dispatchEvent(new Event("change", { bubbles: true }));

        syncActivePill(select, pillGroup);
        updateErrorState(select, pillGroup, fieldCard);
      });

      pillGroup.appendChild(pill);
    });

    select.addEventListener("change", function () {
      syncActivePill(select, pillGroup);
      updateErrorState(select, pillGroup, fieldCard);
    });

    select.classList.add("dml-pill-source");
    wrapper.appendChild(pillGroup);
    select.dataset.dmlProcessed = "true";

    updateErrorState(select, pillGroup, fieldCard);
  }

  function processGiftUI() {
    const widget = document.querySelector(".appstle_fields_wrapper");
    if (!widget) return;

    updatePlanHeading();
    markFullWidthFields(widget);

    const selects = widget.querySelectorAll(".appstleCustomSelectField select");
    selects.forEach(createPills);
  }

  let scheduled = false;

  function scheduleProcess() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      processGiftUI();
      scheduled = false;
    });
  }

  function startWatching() {
    processGiftUI();

    const observer = new MutationObserver(() => {
      scheduleProcess();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener(
      "submit",
      function () {
        document
          .querySelectorAll(".appstle_fields_wrapper .appstleCustomSelectField select")
          .forEach((select) => {
            const fieldCard = select.closest(".appstleCustomSelectField");
            const pillGroup = fieldCard?.querySelector(".dml-pill-group");

            if (pillGroup) {
              updateErrorState(select, pillGroup, fieldCard);
            }
          });
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startWatching);
  } else {
    startWatching();
  }
})();